import { render, staticRenderFns } from "./AdsCampaignEventForm.vue?vue&type=template&id=45250ee2"
import script from "./AdsCampaignEventForm.vue?vue&type=script&lang=js"
export * from "./AdsCampaignEventForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports